/**
 * Phase 7: Toast-style success message from location.state.
 * Renders when location.state?.message; auto-hides after duration; close button.
 */
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import styles from "./SuccessMessage.module.scss";

interface SuccessMessageProps {
  duration?: number;
}

const SuccessMessage: React.FC<SuccessMessageProps> = ({ duration = 5000 }) => {
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const msg = (location.state as { message?: string } | null)?.message;
    if (msg) {
      setMessage(msg);
      setVisible(true);
      const t = window.setTimeout(() => setVisible(false), duration);
      return () => clearTimeout(t);
    }
  }, [location.state, duration]);

  if (!visible || !message) return null;

  return (
    <div className={styles.toast} role="status">
      <div className={styles.content}>
        <span className={styles.icon} aria-hidden>✓</span>
        <span className={styles.text}>{message}</span>
        <button
          type="button"
          className={styles.close}
          onClick={() => setVisible(false)}
          aria-label="Dismiss"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default SuccessMessage;
